export default __webpack_public_path__ + "static/char-s-43-en-2be7ab3b4705caa54b2178a5698d984a.png";